import { render, staticRenderFns } from "./clslist.vue?vue&type=template&id=232c881e&"
import script from "./clslist.vue?vue&type=script&lang=js&"
export * from "./clslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports